<!--
 * @Description: 微信绑定
 * @Author: xu wei
 * @Date: 2020-03-07 15:43:10
 * @LastEditTime: 2020-07-28 16:35:02
 * @LastEditors: gao shuai
 -->
<template>
  <div class="partinstall">
    <div class="bg_fff">
      <div class="gs_listcontainer">
        <p class="tip_red">微信绑定</p>
        <dl class="clearfix">
          <dt>微信</dt>
          <dd>{{isBindWei?'已绑定':'绑定微信公众号可查询玩家订单信息'}}</dd>
          <dd style="float: right;color: #3c8dbc;cursor: pointer;">
            <!-- <span v-if="isBindWei" @click="dialog.show=true">解绑</span> -->
            <!-- <span @click="bindWei">绑定</span> -->
          </dd>
        </dl>
        <table class="bindwei">
          <tr>
            <td class="tit">已绑定微信</td>
            <td style="padding-left: 18px; padding-right:80px;position: relative;">
              <el-tag v-for="(item,i) in isbindWeilist" :key="'isbind'+i" closable type="success" @close="unbindWeixin(item.openId)">{{item.nickname}}</el-tag>
              <el-button style="margin:5px 0;" size="mini" type="primary" @click="dialog.show=true">+ 增加绑定微信</el-button>
              <span v-if="!secondValue" class="authority" @click="dialog1.show=true">权限管理</span>
            </td>
          </tr>
        </table>
        <!-- <dl class="clearfix">
          <dt style="height:100%;">已绑定微信</dt>
          <dd style="padding-top:0">
            <el-tag v-for="(item,i) in isbindWei" :key="'isbind'+i" closable type="success">{{item}}</el-tag>
          </dd>
        </dl> -->
        <p style="font-size: 14px;margin-top:18px;">注：扫码绑定公众号请输入验证码，提示点击链接完成绑定即可</p>
      </div>
    </div>
    <div class="bg_fff mgt20" v-if="isbindWeilist.length>0&&secondValue">
      <div class="weixinbox">
        <p class="tip_red">微信权限管理</p>
        <table>
          <tr v-for="(item,i) in isbindWeilist" :key="'Authority'+i">
            <td class="tit_td" style="text-align: center;"><img v-if="item.headImgUrl" :src="item.headImgUrl" width="35" height="35"><p>{{item.nickname}}</p></td>
            <td>
              <ul class="clearfix1">
                <li class="clearfix1">
                  <span class="tit">发送充值信息</span>
                  <div class="contbox">
                    <el-switch v-model="item.isSendRecharge" active-color="#13ce66" inactive-color="#ff4949" @change="changeWeixin(item.id,'isSendRecharge',item.isSendRecharge,i)"></el-switch>
                  </div>
                </li>
                <!-- <li class="clearfix1">
                  <span class="tit">申请提现</span>
                  <div class="contbox">
                    <el-switch v-model="item.isWithdrawal" active-color="#13ce66" inactive-color="#ff4949" @change="changeWeixin(item.id,'isWithdrawal',item.isWithdrawal,i)"></el-switch>
                  </div>
                </li> -->
                <li class="clearfix1">
                  <span class="tit">查看提现记录</span>
                  <div class="contbox">
                    <el-switch v-model="item.isWithdrawalLog" active-color="#13ce66" inactive-color="#ff4949" @change="changeWeixin(item.id,'isWithdrawalLog',item.isWithdrawalLog,i)"></el-switch>
                  </div>
                </li>
                <li class="clearfix1">
                  <span class="tit">编辑安装分区</span>
                  <div class="contbox">
                    <el-switch v-model="item.isInstallPartition" active-color="#13ce66" inactive-color="#ff4949" @change="changeWeixin(item.id,'isInstallPartition',item.isInstallPartition,i)"></el-switch>
                  </div>
                </li>
                <li class="clearfix1">
                  <span class="tit">手动补发</span>
                  <div class="contbox">
                    <el-switch v-model="item.isManualReissue" active-color="#13ce66" inactive-color="#ff4949" @change="changeWeixin(item.id,'isManualReissue',item.isManualReissue,i)"></el-switch>
                  </div>
                </li>
                <li class="clearfix1">
                  <span class="tit">整区补发</span>
                  <div class="contbox">
                    <el-switch v-model="item.isAllReissue" active-color="#13ce66" inactive-color="#ff4949" @change="changeWeixin(item.id,'isAllReissue',item.isAllReissue,i)"></el-switch>
                  </div>
                </li>
                <li class="clearfix1">
                  <span class="tit">编辑分组管理</span>
                  <div class="contbox">
                    <el-switch v-model="item.isEditGroup" active-color="#13ce66" inactive-color="#ff4949" @change="changeWeixin(item.id,'isEditGroup',item.isEditGroup,i)"></el-switch>
                  </div>
                </li>
                <li class="clearfix1">
                  <span class="tit">编辑分区管理</span>
                  <div class="contbox">
                    <el-switch v-model="item.isEditPartition" active-color="#13ce66" inactive-color="#ff4949" @change="changeWeixin(item.id,'isEditPartition',item.isEditPartition,i)"></el-switch>
                  </div>
                </li>
              </ul>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <!-- 绑定信息二维码 -->
    <el-dialog title="" :visible.sync="dialogCode.show" @close="dialogCodeInit" custom-class="gs_dialog" width="300px">
      <div class="tc pdt20 pdb25">
        <img style="width:200px;height:200px;" :src="imgurl" alt="">
        <p class="mgt5">请用微信扫码关注后回复: <span style="color:green; fontsize:24px">{{valCode}}</span></p>
        <p class="mgt5">(一分钟内有效)</span></p>
      </div>
    </el-dialog>
    <!-- 二级密码的确认 -->
    <el-dialog title="提示" :visible.sync="dialog1.show" @close="dialog1.secondPassword=''" custom-class="gs_dialog" width="400px">
      <div class="passwordBox">
        <span class="tit">二级密码：</span>
        <div class="inputBox">
          <el-input style="width:220px;" type="password" size="small" v-model="dialog1.secondPassword" @keyup.enter.native="authorityClick" placeholder="请输入二级密码"></el-input>
        </div>
      </div>
      <p class="tc pdb10">
        <el-button size="small" type="primary" @click="authorityClick">确定</el-button>
        <el-button size="small" type="info" @click="dialog1.show=false">取消</el-button>
      </p>
    </el-dialog>
    <!-- 解绑微信二级密码的确认 -->
    <el-dialog title="提示" :visible.sync="dialog.show" @close="dialoginit" custom-class="gs_dialog" width="400px">
      <div class="passwordBox">
        <span class="tit">二级密码：</span>
        <div class="inputBox">
          <el-input v-if="isbindFlag" style="width:220px;" type="password" size="small" v-model="dialog.secondPassword" @keyup.enter.native="unbindWei" placeholder="请输入二级密码"></el-input>
          <el-input v-else style="width:220px;" type="password" size="small" v-model="dialog.secondPassword" @keyup.enter.native="bindWei" placeholder="请输入二级密码"></el-input>
        </div>
      </div>
      <p class="tc pdb10">
        <el-button v-if="isbindFlag" size="small" type="primary" @click="unbindWei">确定</el-button>
        <el-button v-else size="small" type="primary" @click="bindWei">确定</el-button>
        <el-button size="small" type="info" @click="dialog.show=false">取消</el-button>
      </p>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: false,
      secondValue: false, // 微信管理二级密码
      serverBind: {
        weixin: ''
      },
      isbindFlag: false, // 二级密码时的绑定和解绑的flag, true为解绑，false为绑定状态
      openId: '',
      isbindWeilist: [], // 已经绑定的微信
      isBindWei: false, // 是否绑定微信
      imgurl: '',
      valCode: '111111',
      dialogCode: {
        show: false
      },
      timer: null,
      dialog: {
        show: false,
        secondPassword: ''
      },
      dialog1: {
        show: false,
        secondPassword: ''
      }
    };
  },
  methods: {
    // 查询是否绑定微信公众号
    isBindWeixi() {
      this.$api.personCenter
        .isBandweixi()
        .then((data) => {
          this.isBindWei = data.data;
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 轮询是否绑定微信公众号
    checkBindWeixi() {
      this.$api.personCenter
        .isBandsingle()
        .then((data) => {
          if (data.data) {
            clearInterval(this.timer);
            this.timer = null;
            this.dialogCode.show = false;
            this.$messageSuccess('绑定成功！');
            this.isBindWeixi();
            this.getWeixinlist();
          }
        })
        .catch(() => {
          // this.$messageError(err.message);
        });
    },
    // 绑定微信
    bindWei() {
      if (this.dialog.secondPassword === '') {
        this.$messageError('请输入二级密码！');
        return;
      }
      this.$api.personCenter
        .userCode({ password: this.dialog.secondPassword })
        .then((data) => {
          console.log(data);
          if (data.status === 200) {
            this.imgurl = data.data.data;
            this.valCode = data.data.valCode;
            console.log(this.valCode);
            this.dialog.show = false;
            this.dialogCode.show = true;
            this.timer = setInterval(() => {
              this.checkBindWeixi();
            }, 1000);
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 解绑微信
    unbindWei() {
      if (this.dialog.secondPassword === '') {
        this.$messageError('请输入二级密码！');
        return;
      }
      this.$api.personCenter
        .unbindwei({
          password: this.dialog.secondPassword,
          openId: this.openId
        })
        .then((data) => {
          this.$messageSuccess('解绑成功！');
          this.dialog.show = false;
          this.openId = '';
          this.isbindFlag = false;
          this.isBindWeixi();
          this.getWeixinlist();
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 解绑微信
    unbindWeixin(id) {
      this.isbindFlag = true;
      this.openId = id;
      this.dialog.show = true;
    },
    // 绑定微信二维码的弹框初始化
    dialogCodeInit() {
      this.imgurl = '';
      clearInterval(this.timer);
      this.timer = null;
    },
    // 获取已绑定的微信列表
    getWeixinlist() {
      this.$api.personCenter
        .isbindWeixin()
        .then((data) => {
          if (data.status === 200) {
            this.isbindWeilist = data.data;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 初始化二级密码数据
    dialoginit() {
      this.dialog.secondPassword = '';
      this.isbindFlag = false;
      this.openId = '';
    },
    // 微信权限管理
    changeWeixin(id, str, state, index) {
      this.$api.personCenter
        .changeWeixin({
          id: id,
          permissionName: str,
          state: state
        })
        .then((data) => {
          if (data.status === 200) {
          }
        })
        .catch((err) => {
          this.isbindWeilist[index][str] = !this.isbindWeilist[index][str];
          this.$messageError(err.message);
        });
    },
    // 权限管理二级密码确认
    authorityClick() {
      if (this.dialog1.secondPassword === '') {
        this.$messageError('请输入二级密码！');
        return;
      }
      this.$api.personCenter
        .checkSecondary({
          password: this.dialog1.secondPassword
        })
        .then((data) => {
          if (data.data) {
            this.secondValue = true;
            this.dialog1.show = false;
          } else {
            this.$messageError('二级密码错误');
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    }
  },
  created() {
    this.isBindWeixi();
    this.getWeixinlist();
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>

<style lang="scss" scoped>
.tip_red {
  color: #3c8dbc;
  padding: 10px 0px;
  font-weight: bold;
  font-size: 15px;
}
.gs_listcontainer {
  padding-top: 0;
  padding-bottom: 15px;
  margin-left: 20px;
  .clearfix {
    border: 1px solid #d9edf7;
    width: 95%;
    margin-bottom: 1px;
    padding-left: 0px;
    box-sizing: border-box;
    .mgl20 {
      float: right;
    }
    dt {
      background-color: #d9edf7;
      padding-right: 10px;
    }
    dd {
      padding-top: 5px;
    }
  }
}
.mg2 {
  float: right;
  margin-top: -20px;
}
.opeartbox {
  border: 1px solid #00bcd4;
  width: 97%;
}
.line_tip {
  color: #999;
  font-size: 14px;
  margin-left: 20px;
}
.right {
  float: right;
  margin-right: 4%;
}
.el-form-item {
  margin-bottom: 10px;
}
.editserverBox {
  padding-left: 20px;
  .list {
    margin-bottom: 10px;
    .tit {
      float: left;
      width: 90px;
      height: 32px;
      line-height: 32px;
    }
    .content {
      float: left;
      width: 250px;
    }
  }
  .serveList {
    li {
      position: relative;
      float: left;
      width: 100px;
      text-align: center;
      border: 1px solid #ccc;
      border-radius: 4px;
      margin-right: 15px;
      margin-bottom: 10px;
      overflow: hidden;
      .tit {
        background: #3c8dbc;
        color: #fff;
        height: 22px;
        line-height: 22px;
      }
      .numberbox {
        height: 25px;
        line-height: 25px;
        color: green;
        font-size: 13px;
      }
      &:hover {
        .mask {
          top: 0;
        }
      }
      .mask {
        position: absolute;
        transition: top 0.3s;
        top: 100%;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.8);
        color: #fff;
        cursor: pointer;
        line-height: 50px;
      }
    }
  }
}
.passwordBox {
  padding-left: 20px;
  display: flex;
  flex-flow: row nowrap;
  padding-bottom: 16px;
  .tit {
    display: block;
    width: 100px;
    height: 32px;
    line-height: 32px;
  }
}
.bindwei {
  width: 95%;
  border: 1px solid #d9edf7;
  .tit {
    width: 100px;
    background: #d9edf7;
    padding-right: 10px;
    font-size: 14px;
    text-align: right;
    color: #333;
  }
  .el-tag {
    margin: 5px 10px 5px 0;
  }
}
.weixinbox {
  margin-left: 20px;
  .clearfix1:after {
    content: '';
    display: table;
    clear: both;
    border-spacing: 0;
  }
  table {
    width: 95%;
    margin-top: -10px;
    border-collapse: separate;
    border-spacing: 0 10px;
    tr {
      td {
        border: 1px solid #d9edf7;
        ul {
          margin: 0 100px 0 70px;
          li {
            float: left;
            margin-right: 60px;
            .tit {
              float: left;
              height: 40px;
              line-height: 40px;
              font-size: 13px;
              width: 90px;
              text-align: right;
              color: #313131;
            }
            .contbox {
              float: left;
              margin-top: 7px;
              margin-left: 20px;
            }
          }
        }
      }
      .tit_td {
        width: 98px;
        background: #d9edf7;
        padding-right: 10px;
        text-align: right;
        font-size: 14px;
        color: #333;
      }
    }
  }
}
.authority {
  position: absolute;
  font-size: 14px;
  right: 10px;
  top: 12px;
  color: #63aafa;
  cursor: pointer;
}
</style>
